import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class CheckUnsavedPosts {
  abstract showNavigationAlert(): Observable<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedPostGuard  {
  canDeactivate(
    component: CheckUnsavedPosts,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return component.showNavigationAlert();
  }
}
